import React from 'react';
import dotArrow from '../../assets/images/dotArrow.png';

const GroupFilter = ({ groups, setGroupFilter, groupFilter, setCurpage }) => {
  return (
    <div className='selectBox'>
      <div className='selectWraper'>
        <img src={dotArrow} className='selectBoxIcon' alt='imagedot' />
        <select
          onChange={(e) => {
            setCurpage(1);
            setGroupFilter(e.target.value);
          }}
          value={groupFilter}
        >
          {/* <option value=''>Filter</option> */}
          <option value=''>All Groups</option>
          {groups &&
            groups.length &&
            groups.map((group, l) => {
              return (
                <option key={l} value={group._id}>
                  {group.groupName}
                </option>
              );
            })}
        </select>
      </div>
    </div>
  );
};

export default GroupFilter;
